<template lang="pug">
  ListLayout(
    v-if='genre'
    :title='$route.meta.title'
  )
    ItemList(
      type='albums'
      view='card'
      :empty-message='$l10n("NOT_FOUNDED")'
      :key='genreId'
      :items='genreAlbums'
      :params='params'
      :links='genreAlbums.length ? orders : []'
      :year-select='yearSelect'
      :lang-select='langSelect'
      :pagination='pagination'
    )
</template>

<script>
import PageLoader from "@/services/pageLoader";
import paginationPage from "@/mixins/pages/pagination.mixin";
import itemsOrder from "@/mixins/shared/itemsOrder.mixin";
import errorHandler from "@/services/errorHandler";

import { mapGetters, mapActions } from "vuex";

const strategy = async function(route, ctx) {
  const params = {
    year: null,
    lang: null,
    order: "lastest",
    page: 1,
    ...route.query,
    ...(route.meta.params || {})
  };

  try {
    const id = PageLoader.getIdFromRoute(route);
    const { genre = {} } = await PageLoader.getGenre({ id });

    params.id = id;
    ctx.genreId = id;
    ctx.genreName = genre.name;

    route.meta.title = `${genre.name}`;
  } catch (error) {
    errorHandler.resolve(error);
  }

  try {
    const {
      albums = [],
      pagination = null
    } = await PageLoader.getAlbumsByGenre(params);

    ctx.albumsIds = albums.map(item => item.id);
    ctx.pagination = pagination;
    ctx.params = params;
  } catch (error) {
    errorHandler.add(error);
  }

  try {
    const { years = null } = await PageLoader.getGenreYears({
      id: ctx.genreId
    });

    ctx.years = years;
  } catch (error) {
    errorHandler.add(error);
  }
};

export default {
  name: "GenreAlbumsPage",
  mixins: [paginationPage(strategy), itemsOrder],
  data() {
    return {
      genreName: "",
      genreId: null,
      albumsIds: [],
      params: {}
    };
  },
  computed: {
    ...mapGetters({
      albums: "albums/albums",
      genres: "genres/genres"
    }),
    genre() {
      return this.genres[this.genreId];
    },
    genreAlbums() {
      return this.albumsIds.map(id => this.albums[id]);
    }
  },
  methods: {
    ...mapActions({
      setGenresListState: "page/setGenresListState"
    })
  },
  mounted() {
    setTimeout(() => {
      this.setGenresListState({
        type: "albums",
        title: this.genreName
      });
    });
  },
  updated() {
    this.setGenresListState({
      type: "albums",
      title: this.genreName
    });
  }
};
</script>
